<editor [id]="editorId" [initialValue]="content" [init]="config" [style.height]="'inherit'"></editor>
